import React from 'react'
import PropTypes from 'prop-types'

import {
  TablePagination as TablePaginationMaterial,
  useMediaQuery,
  Box,
} from '@material-ui/core'

import { Skeleton } from '@material-ui/lab'

import { useTheme } from '@material-ui/styles'

const TablePagination = ({
  count,
  page,
  rowsPerPage,
  isLoading = false,
  onChangePage,
  onChangeRowsPerPage,
  ...rest
}) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  if (isLoading) {
    return (
      <Box py={2} display="flex" alignItems="center" justifyContent="flex-end">
        <Skeleton variant="rect" width={200} height={20} />
      </Box>
    )
  }

  return (
    <TablePaginationMaterial
      component="div"
      count={count}
      page={page - 1}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
      labelRowsPerPage={isDesktop ? 'Por página' : ''}
      nextIconButtonProps={{ size: 'small' }}
      backIconButtonProps={{ size: 'small' }}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      {...rest}
    />
  )
}

TablePagination.propTypes = {
  count: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  isLoading: PropTypes.bool,
  onChangePage: PropTypes.func,
  onChangeRowsPerPage: PropTypes.func,
}

export default TablePagination
